import PageComponent from '../component/page-component';


class Toggler extends PageComponent {

	constructor({
		root,
		element,
		eventType = 'click',
		toggledClass = 'toggled',
		preventDefault = true,
		blurOnToggle = true,
		forAttribute = 'id',
		targetAction = 'toggle',
		targetDataAttributeId = false,
		dynamicTarget = false,
		beforeToggleEvent = 'toggler:beforetoggle',
		toggleEvent = 'toggler:toggle',
		enabledByCss = false,
		cssEnabledProperty = 'togglerEnabled',
		options = {
			invertValue: false
		},
		toggledOptions = {}
	}) {
		super({root: root, element: element});
		this.defaults.eventType = eventType;
		this.defaults.toggledClass = toggledClass;
		this.defaults.preventDefault = preventDefault;
		this.defaults.blurOnToggle = blurOnToggle;
		this.defaults.forAttribute = forAttribute;
		this.defaults.targetAction = targetAction;
		this.defaults.targetDataAttributeId = targetDataAttributeId;
		this.defaults.dynamicTarget = dynamicTarget;
		this.defaults.beforeToggleEvent = beforeToggleEvent;
		this.defaults.toggleEvent = toggleEvent;
		this.defaults.enabledByCss = enabledByCss;
		this.defaults.cssEnabledProperty = cssEnabledProperty;
		this.defaults.options = options;
		this.defaults.toggledOptions = toggledOptions;
		this.targetSelector = null;
		this.targets = null;
		this.toggled = null; // will be a boolean after prepare()
		this.busy = false;
	}


	prepare() {
		const data = this.dataAttr().getAll();
		this.options = data.options;
		this.toggledOptions = data.toggledOptions;
		this.targetDataAttributeId = data.targetDataAttributeId;
		this.eventType = data.eventType;
		this.beforeToggleEvent = data.beforeToggleEvent;
		this.toggleEvent = data.toggleEvent;
		// console.log(this, 'our context');
		// if the for attribute is not available, it fallbacks to the href anchor value
		if ('for' in data) {
			this.targetSelector = this.dataSelector(data.forAttribute, data.for);
		} else if (this.element.hasAttribute('href')) {
			const href = this.element.getAttribute('href');

			const regexMatchHash = /#.*/;
			const found = href.match(regexMatchHash);
			if (found) {
				this.targetSelector = found[0];
			}
		}

		this.toggled = this.classList(this.element).contains(data.toggledClass);

		this.listeners.toggle = this.events.on(this.element, this.eventType, this.onToggle.bind(this));
	}


	onToggle(event) {
		const data = this.dataAttr().getAll();
		if (data.preventDefault) {
			event.preventDefault();
		}
		if (data.blurOnToggle) {
			this.element.blur();
		}
		if (!data.enabledByCss || this.cssData().get(data.cssEnabledProperty, true)) {
			this.toggle();
		}
	}


	toggle(value = null, options = {}, toggledOptions = {}) {
		const data = this.dataAttr().getAll();
		const originalValue = value;
		return Promise.resolve().then(() => {
			if (this.busy) {
				return false;
			}
			value = (value === null ? !this.toggled : !!value);
			if (value === this.toggled) {
				return false;
			} else {
				this.busy = true;
				options = Object.assign({}, this.options, options);
				toggledOptions = Object.assign({}, this.toggledOptions, toggledOptions);
				return this.toggling(originalValue, value, options, toggledOptions, data);
			}
		}).then((complete) => {
			if (complete) {
				this.busy = false;
				this.events.trigger(this.element, data.toggleEvent, {component: this, toggled: this.toggled});
			}
		});
	}


	toggling(originalValue, value, options, toggledOptions, data) {
		const beforeEvent = this.events.trigger(this.element, data.beforeToggleEvent, {component: this, toggled: this.toggled, intention: value});
		if (beforeEvent.defaultPrevented) {
			this.busy = false;
			return false;
		}
		this.classList(this.element).toggle(data.toggledClass, value);
		this.element.setAttribute('aria-expanded', value);
		this.toggled = value;
		if (this.targetSelector) {
			const targets = this.getToggledComponents();
			const toggledValue = options.invertValue ? !value : originalValue;
			const promises = targets.map((target) => target[data.targetAction](toggledValue, toggledOptions));
			if (promises.length) {
				return Promise.all(promises).then(() => true);
			}
		}
		return true;
	}


	isBusy() {
		return this.busy;
	}


	isToggled() {
		return this.toggled;
	}


	getToggleEventType() {
		return this.toggleEvent;
	}


	getBeforeToggleEventType() {
		return this.beforeToggleEvent;
	}


	getToggledComponents() {
		if (this.targetSelector && (this.targets === null || this.dataAttr().get('dynamicTarget'))) {

			if (this.targetDataAttributeId) {
				this.targets = this.components.queryComponents(this.root, this.dataSelector('id', this.targetSelector.substring(1)));
			} else {
				this.targets = this.components.queryComponents(this.root, this.targetSelector);
			}

		}

		return this.targets;
	}

}

export default Toggler;
